import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import LoaderPage from "../components/loaders/LoaderPage";
import DelegationRoles from "../features/delegation_roles";
import { Suspense } from "react";
import DelegationHome from "../features/delegation_roles/pages/Home/DelegationHome";
import DelegationForm from "../features/delegation_roles/pages/DelegationForm/DelegationForm";

/* DELEGATION */
export const delegationRoutes = (
    <Route
        path={ROUTES.delegation_roles.home}
        element={
            <Suspense fallback={<LoaderPage />}>
                <DelegationRoles />
            </Suspense>
        }
        key="delegation"
    >
        <Route index path="" element={<DelegationHome />} />
        <Route index path="assign/:type_form" element={<DelegationForm />} />
    </Route>
);
